import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import { InfoPopover } from '@adsk/alloy-react-tooltip';

type SchedulePopoverProps = {
  popoverMessage?: ReactNode;
  label: ReactNode;
  shouldDisplayPopover: boolean;
};

const SchedulePopover: FC<SchedulePopoverProps> = ({
  popoverMessage,
  label,
  shouldDisplayPopover,
}) => (
  <div
    css={[
      {
        display: 'flex',
      },
    ]}
  >
    {label}
    {shouldDisplayPopover && (
      <InfoPopover
        message={popoverMessage}
        placement={InfoPopover.PLACEMENTS.TOP}
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          marginLeft: '5px',
        }}
      />
    )}
  </div>
);

SchedulePopover.propTypes = {
  /**
   * Label to show on top
   */
  label: PropTypes.any.isRequired,
  /**
   * Message shown as popover content
   */
  popoverMessage: PropTypes.any,
  /**
   * Whether or not to show the info popover
   */
  shouldDisplayPopover: PropTypes.bool.isRequired,
};

export default SchedulePopover;
